import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
export default function (country, translationBaseKeyPath) {
  switch (country) {
    case Country.US:
      return `${translationBaseKeyPath}.US`;
    case Country.GB:
      return `${translationBaseKeyPath}.GB`;
    case Country.CA:
      return `${translationBaseKeyPath}.CA`;
    default:
      throw new Error('Country not supported');
  }
}